import * as moment from 'moment';
import { ContextualField, PropertyType, IValueViewModel, Group, TimeUnit, GroupNameDto, ObjectType, IdentifierType, IFrequency } from '../../../../models/index';

export const linkedGuidProperty: ContextualField = {
    modelName: 'linkedGuid',
    propertyType: PropertyType.ViewModel,
    label: 'Linked identifier',
    propertyName: 'linkedGuidProperty',
    icon: 'fa-chain',
    required: true,
    messages: [{ key: 'required', value: 'An identifier is required' }],
    extraData: {}
};

export function filterViewModels(group: Group, defaultFrequency: IFrequency) {
    return (list: IValueViewModel[]) => {
        list = list.filter(vm => vm.groupList.length
            && (vm.groupList[0].guid !== group?.guid || vm.identifierType !== IdentifierType.CalculatedValue)
            && vm.objectType !== ObjectType.Tag);
        if (group && group.frequency.interval > 0) {
            const span = getSpan(group);
            list = list.filter(vm => vm.groupList.length && (getSpan(vm.groupList[0]) <= span));
        } else {
            list = list.filter(vm => vm.groupList.length && (vm.groupList[0].frequency.interval === 0 || getSpan(vm.groupList[0]).asSeconds() === getSpanFromFrequency(defaultFrequency).asSeconds()));
        }
        return list;
    };
}

function getSpan(group: Group | GroupNameDto) {
    return moment.duration(
        group.frequency.interval,
        TimeUnit[group.frequency.intervalTimeUnit] as moment.unitOfTime.DurationConstructor
    );
}

function getSpanFromFrequency(frequency : IFrequency){
    return moment.duration(
        frequency.interval,
        TimeUnit[frequency.intervalTimeUnit] as moment.unitOfTime.DurationConstructor
    );
}